import { api } from '@/common/api';
import isEqual from 'lodash/isEqual';
const store = {
    namespaced: true,
    state() {
        return {
            setting: {},
            isNotLoaded: true
        };
    },

    mutations: {
        setPreferences(state, data) {
            state.setting = data.data.data.setting;
            state.isNotLoaded = false;
        },
        clearStore(state) {
            state.setting = {};
        }
    },
    actions: {
        async getPreferences({ state, commit }) {
            if (state.isNotLoaded) {
                try {
                    commit('setPreferences', await api.get('/preferences/'));
                } catch (e) {
                    throw new Error(e);
                }
            }
        },
        async setPreferences({ state, commit }, data) {
            const section = Object.keys(data)[0];
            if (!state.setting || state.setting[section] === undefined || !isEqual(state.setting[section], data[section])) {
                try {
                    commit('setPreferences', await api.post('/preferences/', data));
                } catch (e) {
                    throw new Error(e);
                }
            }
        }
    },
    getters: {}
};

export default store;
